import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';
import ImageSliderPlante from './carrousselplante';


const Plantes = (props) => {

  return (
    <div>  
            <Header />

    <div id="activites">

      <div className="container">
                             <div className="col-xs-12 col-md-12">

<br></br>
<br></br>
        <div className="section-title">
          <h2>Les plantes</h2>
            <br></br>
              <br></br>
<br></br>
                  <div className="activites-list">

<p>
Chez DELPHIA PAUL, fleuriste à Chennevières-sur-Marne, je vous propose une sélection de plantes d’intérieur et de compositions végétales pour apporter une touche de nature, d’élégance et de bien-être à votre quotidien.
  <br /><br />

 Chaque plante est choisie avec soin pour sa qualité, sa beauté et sa facilité d’entretien. 
 <br></br>Je vous accompagne dans votre choix en fonction de votre espace, de sa luminosité et de vos envies, afin de vous proposer des créations qui vous ressemblent.
  <br /><br />

 Je réalise également des compositions végétales sur mesure, pour les particuliers comme pour les professionnels, toujours avec une approche artisanale et harmonieuse.

  <br /><br />
Offrir une plante ou une coupe de plantes, c’est offrir un cadeau durable et plein de sens. 
<br></br>
<br></br>Et si vous faisiez entrer un peu de nature chez vous ?!!
  <br /><br />

</p>
<br></br>
          <br></br>
<ImageSliderPlante />
        </div>
       
       
      </div>
      </div>
      </div></div>
  
      < Footer />

    </div>

  );
};
export default Plantes;